import Vue from 'vue';
import ElementUi from 'element-ui';

import { getElementUILanguage } from '@shared/i18n';

import applyElOptionProxy from './el-option'

applyElOptionProxy(ElementUi)

Vue.use(ElementUi, {
  locale: getElementUILanguage(),
});
